<div class="modal fade" tabindex="-1" [id]="modalId"> </div>

<nz-modal
    [(nzVisible)]="isVisible"
    nzTitle="Add User"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="save()"
	[nzOkLoading]="isConfirmLoading"
    [nzOkDisabled]="form.invalid || usernameValidateStatus !== 'success'"
	[nzCancelDisabled]="isConfirmLoading"
    [nzMaskClosable]="!isConfirmLoading"
    [nzKeyboard]="!isConfirmLoading"
    [nzClosable]="!isConfirmLoading"
    nzOkText="Save"
    nzCancelText="Cancel"
    [nzWidth]="600">

    <ng-container *nzModalContent>
        <form nz-form [formGroup]="form" [nzLayout]="'horizontal'">
            
            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Username</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" 
                    nzHasFeedback
                    [nzValidateStatus]="usernameValidateStatus"
                    [nzErrorTip]="usernameErrorTpl"
                    [nzValidatingTip]="'Checking availability...'">
                    
                    <input nz-input formControlName="newUsername" placeholder="Username" autocomplete="new-username" />
                    
                    <ng-template #usernameErrorTpl>
                        @if (form.get('newUsername')?.errors?.['required']) {
                            Username is required
                        } @else if (form.get('newUsername')?.errors?.['minlength']) {
                            Minimum 5 characters
                        } @else if (form.get('newUsername')?.errors?.['maxlength']) {
                            Maximum 20 characters
                        } @else if (form.get('newUsername')?.errors?.['usernameTaken']) {
                            Username is already taken
                        }
                    </ng-template>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Password</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" [nzErrorTip]="passwordErrorTpl">
                    <input nz-input type="password" formControlName="newPassword" placeholder="Password" autocomplete="new-password" />
                    <ng-template #passwordErrorTpl>
                        @if (form.get('newPassword')?.errors?.['required']) {
                            Password is required
                        } @else if (form.get('newPassword')?.errors?.['minlength']) {
                            Minimum {{ form.get('newPassword')?.errors?.['minlength']?.requiredLength }} characters
                        } @else if (form.get('newPassword')?.errors?.['maxlength']) {
                            Maximum {{ form.get('newPassword')?.errors?.['maxlength']?.requiredLength }} characters
                        }
                    </ng-template>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Confirm</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" 
                    [nzValidateStatus]="confirmPasswordStatus"
                    [nzErrorTip]="confirmErrorTpl">
                    
                    <input nz-input type="password" formControlName="confirmPassword" placeholder="Confirm Password" />
                    
                    <ng-template #confirmErrorTpl>
                        @if (form.get('confirmPassword')?.errors?.['required']) {
                            Confirm Password is required
                        } @else if (form.hasError('passwordMismatch')) {
                            Passwords do not match
                        }
                    </ng-template>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Name</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Name is required (2-20 chars)">
                    <input nz-input formControlName="name" placeholder="Name" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Surname</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Surname is required (3-20 chars)">
                    <input nz-input formControlName="surname" placeholder="Surname" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">Email</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" [nzErrorTip]="emailErrorTpl">
                    <input nz-input formControlName="email" placeholder="Email" />
                    <ng-template #emailErrorTpl>
                        @if (form.get('email')?.errors?.['email']) {
                            Please enter a valid email address
                        }
                    </ng-template>
                </nz-form-control>
            </nz-form-item>

        </form>
    </ng-container>

</nz-modal>